import { Action, Dispatch } from 'redux'
import { setEmailErrorAction } from 'reducks/error/actions'

const isValidEmailFormat = (email: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    const ret = regex.test(email)
    if (ret) {
      dispatch(setEmailErrorAction(''))
    } else {
      dispatch(setEmailErrorAction('メールアドレスの形式が正しくありません'))
    }
  }
}

export default isValidEmailFormat
